/*
 * The home page's product tabs (sections/fz-home-products.liquid): WAI-ARIA tabs with automatic
 * activation. The server already renders the first tab selected and the other panels `hidden`, so
 * without this file the first tab's cards still show and sell, and the rest stay one Shop all away;
 * with it, a click or the arrow keys, Home and End move the selection and the roving tabindex.
 *
 * It also drives each row's arrows (below). Delegated from the document, so it needs no
 * per-section setup: every instance of the section, and a section the theme editor re-renders, is
 * handled by the same listeners. Every instance loads this file, so a second load must do nothing.
 */
(function () {
  if (window.FzHomeProducts) return;

  function tabsOf(tablist) {
    return Array.prototype.slice.call(tablist.querySelectorAll("[data-fz-home-tab]"));
  }

  function select(tab, focus) {
    var tablist = tab.closest("[data-fz-home-tablist]");
    if (!tablist) return;
    tabsOf(tablist).forEach(function (other) {
      var on = other === tab;
      other.setAttribute("aria-selected", on ? "true" : "false");
      other.setAttribute("tabindex", on ? "0" : "-1");
      var panel = document.getElementById(other.getAttribute("aria-controls"));
      if (panel) panel.hidden = !on;
    });
    if (focus) tab.focus();
    // A panel that was hidden measured nothing: its arrows are set now that it shows.
    updateAll();
    // lazysizes skips images it cannot see; a panel that was hidden has never been checked.
    if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
  }

  function onClick(event) {
    var tab = event.target.closest && event.target.closest("[data-fz-home-tab]");
    if (tab) select(tab, false);
  }

  function onKeydown(event) {
    var tab = event.target.closest && event.target.closest("[data-fz-home-tab]");
    if (!tab) return;
    var tablist = tab.closest("[data-fz-home-tablist]");
    if (!tablist) return;
    var tabs = tabsOf(tablist);
    var at = tabs.indexOf(tab);
    var next = null;
    switch (event.key) {
      case "ArrowRight":
        next = tabs[(at + 1) % tabs.length];
        break;
      case "ArrowLeft":
        next = tabs[(at - 1 + tabs.length) % tabs.length];
        break;
      case "Home":
        next = tabs[0];
        break;
      case "End":
        next = tabs[tabs.length - 1];
        break;
      default:
        return;
    }
    event.preventDefault();
    select(next, true);
  }

  // The theme editor selects a block by its element; a tab block's element is its tab button.
  function onBlockSelect(event) {
    var tab = event.target && event.target.closest && event.target.closest("[data-fz-home-tab]");
    if (tab) select(tab, false);
  }

  // THE ROW'S ARROWS (from 750px with a fine pointer; CSS hides them on touch, which swipes). One
  // press is a screen of whole cards. An arrow with nothing further to show is disabled, which the CSS
  // fades out, so a row whose cards all fit shows no arrows at all.
  function railOf(node) {
    return node && node.closest && node.closest("[data-fz-home-rail]");
  }

  function update(rail) {
    var track = rail.querySelector("[data-fz-home-track]");
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var prev = rail.querySelector('[data-fz-home-arrow="-1"]');
    var next = rail.querySelector('[data-fz-home-arrow="1"]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
  }

  function updateAll() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-fz-home-rail]"), update);
  }

  function onArrow(event) {
    var arrow = event.target.closest && event.target.closest("[data-fz-home-arrow]");
    if (!arrow) return;
    var rail = railOf(arrow);
    var track = rail && rail.querySelector("[data-fz-home-track]");
    var card = track && track.querySelector(".grid__item");
    if (!card) return;
    // A screen of whole cards a press (the variant's video carousel, accepted as I-79): as many
    // as fit in the column, at least one.
    var gap = parseFloat(getComputedStyle(card.parentNode).columnGap) || 0;
    var step = card.getBoundingClientRect().width + gap;
    var perScreen = Math.max(1, Math.floor((rail.clientWidth + gap) / step));
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    track.scrollBy({
      left: Number(arrow.getAttribute("data-fz-home-arrow")) * perScreen * step,
      behavior: reduce ? "auto" : "smooth",
    });
  }

  function onScroll(event) {
    var rail = railOf(event.target);
    if (rail && event.target.hasAttribute && event.target.hasAttribute("data-fz-home-track")) update(rail);
  }

  document.addEventListener("click", onArrow);
  document.addEventListener("scroll", onScroll, true);
  window.addEventListener("resize", updateAll);
  document.addEventListener("shopify:section:load", updateAll);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateAll);
  } else {
    updateAll();
  }

  document.addEventListener("click", onClick);
  document.addEventListener("keydown", onKeydown);
  document.addEventListener("shopify:block:select", onBlockSelect);

  window.FzHomeProducts = { select: select };
})();
